/** Shared IPC between {@link MicrophoneMonitorHost} (main) and the menubar renderer. */
export const MICROPHONE_MONITOR_IPC = {
  /** Renderer → main when the meeting-detection preference changes. */
  SET_ENABLED: "microphone-monitor:set-enabled",
  /** Main → renderers so every window observes the same preference. */
  ENABLED_CHANGED: "microphone-monitor:enabled-changed",
  /** Main → menubar when mic capture starts or stops. */
  STATE_CHANGED: "mic-state-changed",
} as const;

/** Payload for {@link MICROPHONE_MONITOR_IPC.STATE_CHANGED}. */
export type MicrophoneMonitorState = {
  active: boolean;
};
